// removed by extract-text-webpack-plugin
module.exports = {"Heading":"HeaderText__Heading__2ldn8","SubHeading":"HeaderText__SubHeading__3Hys_","Buttons":"HeaderText__Buttons__PO0kf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderText/HeaderText.css
// module id = 101
// module chunks = 0